import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { usePanelAuth } from "../context/PanelAuthContext";

export default function RequirePanel() {
  const { isAuthenticated } = usePanelAuth();

  if (!isAuthenticated) {
    return <Navigate to="/panel/login" replace />;
  }

  return <Outlet />;
}
